






import { Vue, Prop, Component } from 'vue-property-decorator';

import LockIcon from '@/components/icons/Lock.vue';

type CircleLockVartiantType = 'md' | 'sm';

@Component({
  components: {
    LockIcon
  }
})
export default class CircleLock extends Vue {
  @Prop({ default: 'md' }) readonly size!: CircleLockVartiantType;

  variants = {
    md: {
      circleWidth: 36,
      circleHeight: 36,
      iconWidth: 20,
      iconHeight: 20
    },
    sm: {
      circleWidth: 20,
      circleHeight: 20,
      iconWidth: 12,
      iconHeight: 12
    }
  };

  get variant() {
    return this.variants[this.size];
  }

  get styleCircle() {
    return `width: ${this.variant.circleWidth}px; height: ${
      this.variant.circleHeight
    }px;`;
  }
}
